/**
 * Audience segments. Marketing wanted "everyone"; segmentation gave
 * them everyone, sorted. Segment definitions are shipped to the client
 * because the segments are computed at read time, which is either
 * clever or depressing depending on the meeting.
 */

import { SEGMENTS } from "../decoys/gen/audience-segments";

export interface SegmentDef {
  id: string;
  label: string;
  universes: string[];
  rule: string;
  weight: number;
}

export function allSegments(): SegmentDef[] {
  return SEGMENTS as SegmentDef[];
}

export function segmentFor(universe: string): SegmentDef | null {
  const list = allSegments();
  for (const seg of list) {
    if (seg.universes.includes(universe)) return seg;
  }
  return null;
}

/** Weighted pick for the "recommended for your universe" shelf. */
export function recommendedShelf(universe: string): string {
  const seg = segmentFor(universe);
  if (seg) return `${seg.label} (matched by ${seg.rule})`;
  return "Reader, presumably";
}

export function segmentCount(): number {
  return allSegments().length;
}
